import { HTTPServiceClient } from '@/packages/http/service';
import Organisation from '@/models/Organisation';
import * as endpoint from './endpoints';
import { OrganisationFormData, OrganisationUser } from './types';

/**
 * --------------------------------------------------
 *	Organisation HTTP Serice
 * --------------------------------------------------
 **/
export const OrganisationService = {
  /**
   * Get an organisation details
   * @param { id: string } OrganisationId
   * @returns {Promise<Organisation>} Organisation
   */
  getOrganisation(data: { organisationId: string }): Promise<Organisation> {
    return HTTPServiceClient.get(
      endpoint.ORGANISATION(data.organisationId)
    ).then(({ data }) => data.data);
  },

  /**
   * Adds an organisation
   * @param {OrganisationFormData}
   * @returns {Promise<Organisation>} Organisation
   */
  addOrganisation(data: { data: OrganisationFormData }): Promise<Organisation> {
    return HTTPServiceClient.post(endpoint.ORGANISATION(), {
      ...data.data
    }).then(({ data }) => data);
  },

  /**
   * Edit an organisation
   * @param {OrganisationFormData}
   * @returns {Promise<Organisation>} Organisation
   */
  editOrganisation(data: {
    id: string;
    data: OrganisationFormData;
  }): Promise<Organisation> {
    return HTTPServiceClient.put(endpoint.ORGANISATION(data.id), {
      ...data.data
    }).then(({ data }) => data);
  },

  getOrganisationUser(organisationId: string): Promise<OrganisationUser> {
    return HTTPServiceClient.get(
      endpoint.GET_USER_DETAILS(organisationId)
    ).then(({ data }) => data.data);
  }
};
